import { IRecruiterSearchFilterDTO, ISharePhoneNumber, ITwilio, ITelnyx } from 'wisestep-api';

export const recruiterAdvancedQueryPayload: IRecruiterSearchFilterDTO = {
  recruiterEmailPhrase: '',
  recruiterFirstNamePhrase: '',
  recruiterLastNamePhrase: '',
  size: 10,
  sort: ['createdOn,DESC'],
  page: 0,
};

export const sharePhoneNumberPayload: ISharePhoneNumber = {
  accountId: '',
  emails: [],
  phoneNumber: '',
};

export const twilioPayload: ITwilio = {
  serviceAccountId: '',
  refreshToken: '',
};

export const telnyxPayload: ITelnyx = {
  accessToken: '',
};
